import { render, staticRenderFns } from "./deliveryMethod.vue?vue&type=template&id=3441434c&scoped=true&"
import script from "./deliveryMethod.vue?vue&type=script&lang=js&"
export * from "./deliveryMethod.vue?vue&type=script&lang=js&"
import style0 from "./deliveryMethod.vue?vue&type=style&index=0&id=3441434c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441434c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,Address: require('/app/components/address/index.vue').default})
